export default {
  title: "日報出力",
  outputConditions: "出力条件",
  tripId: "Trip ID",
  leavingWarehouseDate: "出庫日",
  returningWarehouseDate: "帰庫日",
  carNumber: "車番",
  driver: "ドライバー",
  refuelingAmount: "給油量",
  detailsRefuelingInput: "詳細・給油入力",
  edit: "日報編集",
  updatedByAndDate: "最終更新者/日付",
  errorAllDisplay: "エラー内容を全て表示する",
  splitProcessing: "分割中",
  mergeProcessing: "分割取消中",
  alterLeavingProcessing: "出庫日時変更中",
  alterReturningProcessing: "帰庫日時変更中",
  recreateProcessing: "出庫／帰庫日時変更取消中",
  outputLayout: {
    preset: "プリセット",
    reportLayout: "日報レイアウト",
    pageUnit: {
      title: "ページ単位",
      byDay: "日別",
      byDeliveryPlan: "運行別",
      byDriver: "まとめて（ドライバー別）",
    },
    format: "フォーマット",
    allDisplay: "すべての項目を表示する",
    ReacquireData: "点呼データを再取得する",
    byDay: "日別",
    pdf: "PDF",
  },
  failedTripIdsModal: {
    tripIdList: "Trip ID 一覧",
    operationOfficeName: "運営会社名: "
  },
  alterLeavingOrReturning: {
    leavingTitle: "出庫日時変更",
    returningTitle: "帰庫日時変更",
    leavingTime: "出庫時間",
    returningTime: "帰庫時間",
    leavingDateTime: "出庫日時",
    returningDateTime: "帰庫日時",
    confirmTitle: "確認",
    leavingMessage: "以下の通り出庫時間を変更します",
    returningMessage: "以下の通り帰庫時間を変更します",
    execute: "変更",
    cancel: "キャンセル",
    leavingSuccess: "出庫日時変更のリクエストに成功しました。",
    returningSuccess: "帰庫日時変更のリクエストに成功しました。",
  },
  alterLeavingCompleteModal: {
    title: "受付完了",
    messageRow1: "出庫日時変更を受け付けました。",
    messageRow2: "出庫日時変更完了後メールでお知らせします",
  },
  alterReturningCompleteModal: {
    messageRow1: "帰庫日時変更を受け付けました。",
    messageRow2: "帰庫日時変更完了後メールでお知らせします",
  },
  splitForm: {
    title: "日報分割",
    tripId: "Trip ID: ",
    carNumber: "車番: ",
    driver: "ドライバー: ",
    leavingWarehouse: "出庫",
    returningWarehouse: "帰庫",
    firstHalfReturningWarehouse: "帰庫（前半）",
    secondHalfLeavingWarehouse: "出庫（後半）",
    execute: "分割実行",
    confirm: "確認",
    success: "分割のリクエストに成功しました。",
    failedMessage: "日報修正に失敗しました。一時的な技術的問題が発生している可能性があるため、恐れ入りますがしばらく経ってから再度お試しください。",
  },
  splitConfirmModal: {
    title: "日報分割 詳細確認",
    body: "以下の内容で日報を分割します",
    tripId: "Trip ID",
    carNumber: "車番",
    driver: "ドライバー",
    orgDeliveryPlan: "元の運行",
    splitDeliveryPlanNo1: "分割後の運行1",
    splitDeliveryPlanNo2: "分割後の運行2",
    leavingWarehouse: "出庫",
    returningWarehouse: "帰庫",
    announce: "*分割前に修正された内容は破棄されます",
  },
  splitCompleteModal: {
    title: "受付完了",
    messageRow1: "日報分割を受け付けました。",
    messageRow2: "日報分割完了後メールでお知らせします",
  },
  mergeForm: {
    title: "日報分割取消",
    tripId: "Trip ID: ",
    carNumber: "車番: ",
    driver: "ドライバー: ",
    message: "以下の分割を取り消します : ",
    leavingWarehouse: "出庫",
    returningWarehouse: "帰庫",
    execute: "統合実行",
    confirm: "確認",
    success: "統合のリクエストに成功しました。",
  },
  mergeConfirmModal: {
    title: "日報分割取消  実行確認",
    body: "分割の取消を実行しますか？",
    announce: "*分割後に修正された内容は破棄されます",
    exec: "取消実行",
  },
  mergeCompleteModal: {
    title: "受付完了",
    messageRow1: "日報分割取消を受け付けました。",
    messageRow2: "日報分割取消完了後メールでお知らせします",
  },
  recreateForm: {
    title: "出庫／帰庫日時変更取消",
    confirmMessage: "出庫／帰庫日時変更を取消します",
  },
  recreateConfirmModal: {
    title: "出庫／帰庫日時変更取消  実行確認",
    body: "出庫／帰庫日時変更の取消を実行しますか？",
    announce: "*変更後に修正された内容は破棄されます",
    exec: "取消実行",
  },
  recreateCompleteModal: {
    title: "受付完了",
    messageRow1: "出庫／帰庫日時変更取消を受け付けました。",
    messageRow2: "出庫／帰庫日時変更取消完了後メールでお知らせします",
  },
  combineForm: {
    title: "日報統合",
    driver: "ドライバー",
    dateRange: "期間",
    confirm: "確認",
    cancel: "キャンセル",
    maxSelectedMessage: "選択できる日報は5運行までです",
    list: {
      tripId: "Trip ID",
      numberPlate: "車両",
      leavingWarehouse: "出庫日",
      returningWarehouse: "帰庫日",
    },
    rightPane: {
      title: "統合する日報",
      tripId: "Trip ID: ",
      numberPlate: "車両: ",
      leavingWarehouse: "出庫日: ",
      returningWarehouse: "帰庫日: ",
    },
    registerModal: {
      title: "確認",
      message: "以下の通り日報を統合します",
      afterDeliveryPlans: "統合後運行",
      driver: "ドライバー: ",
      leavingWarehouse: "出庫日時: ",
      returningWarehouse: "帰庫日時: ",
      execBtn: "実行",
    },
    completeModal: {
      title: "受付完了",
      messageRow1: "日報統合を受け付けました。",
      messageRow2: "日報統合完了後メールでお知らせします",
    },
  },
  combineRollbackForm: {
    title: "日報統合取消",
    confirmMessage: "日報統合を取消します",
    tripId: "Trip ID: ",
    driver: "ドライバー: ",
    numberPlate: "車番: ",
    leavingWarehouse: "出庫日: ",
    returningWarehouse: "帰庫日: ",
    registerModal: {
      title: "日報統合取消: 実行確認",
      body: "日報統合の取消を実行しますか？",
      announce: "*統合後に修正された内容は破棄されます",
      exec: "取消実行",
    },
    completeModal: {
      title: "受付完了",
      messageRow1: "日報統合取消を受け付けました。",
      messageRow2: "日報統合取消完了後メールでお知らせします",
    },
  },
  updateModal: {
    applicationOfSpecialCaseButton: "特例適用",
    registerUnexpectedEvents: "予期し得ない事象への対応時間の登録",
    editUnexpectedEvents: "予期し得ない事象への対応時間の編集",
    registerSpecialExtensionContinuousOperation: "連続運転時間特別延長の登録",
    inHouseRefuel: "自社給油",
    otherRefuel: "他社給油",
    searchStop: "停車を検索",
    inputRange: "1分〜1440分の範囲で入力",
    moreMinutesStop: "分以上の停車",
    hits: "件ヒット",
    messages: {
      restTimeLessThanThreshold: "休息は3時間以上の時間が必要です。3時間未満の場合は休憩を入力してください。",
      importRefuelAmount: "この運行の給油量を入力してください。",
      courseName1: "コース1（フリー入力）",
      courseName2: "コース2（マスタから選択）",
      noWorkNoSaveStop: "※作業が割当されていない「停止」は保存されません。",
      addSectionNoCalc: "※追加した作業の区間距離は計算されません。",
      notChange: '変更できません',
    },
    overView: {
      leavingWarehouse: "出庫",
      leavingWarehouseMeter: "出庫時メーター",
      returningWarehouse: "帰庫",
      returningWarehouseMeter: "帰庫時メーター",
      totalMileage: "総走行距離",
      actualVehicleDistance: "実車距離",
      roadDistance: "一般/高速/専用道距離"
    },
    workList: {
      No: "No",
      work: "作業",
      address: "住所・拠点",
      arrivalDateTime: "着時刻",
      departureDateTime: "発時刻",
      workTime: "作業時間",
      runningTime: "走行時間",
      runningDistance: "走行距離",
      loadingOrRefueling: "積載/給油",
      edit: "編集",
      selectableRange: "選択可能な範囲",
      autoAssignment: "自動割り当て",
      registSpot: "地点を登録する "
    }
  },
  ignoreLongtimeContinuousWarning: {
    confirmModalTitle: "連続運転特別延長の登録",
    confirmModalBody: "サービスエリア又はパーキングエリア等が満車である等により駐車又は停車できず、やむを得ず連続運転時間が４時間を超える場合は４時間３０分まで運転可能です。",
    updateModalTitle: "連続運転時間超過",
    ignoreBtn: "特別延長",
    ignoredBtn: "特別延長済",
    cantChangeBtn: "設定不可",
    emptyAlerts: "連続運転時間超過はありません。",
  },
  unexpectedEventConfirmModal: {
    title: "予期し得ない事象への対応時間として認められるには基準を満たす必要があります。",
    messages: {
      no1: "1  次のいずれかの事象により生じた運行の遅延に対応するための時間であること。",
      no1of1: "① 運転中に乗務している車両が予期せず故障したこと。",
      no1of2: "② 運転中に予期せず乗船予定のフェリーが欠航したこと。",
      no1of3: "③ 運転中に災害や事故の発生に伴い、道路が封鎖されたこと又は道路が渋滞したこと。",
      no1of4: "④ 異常気象（警報発表時）に遭遇し、運転中に正常な運行が困難となったこと。",
      no2: "2  予期し得ない事象の発生を特定できる客観的な資料を提出できること。",
      example: "（一例）",
      no2of1: "① 修理会社等が発行する故障車両の修理明細書等",
      no2of2: "② フェリー運航会社等のホームページに掲載されたフェリー欠航情報の写し",
      no2of3: "③ 公益財団法人日本道路交通情報センター等のホームページに掲載された \n    道路交通情報の写し（渋滞の日時・原因を特定できるもの）",
      no2of4: "④ 気象庁のホームページ等に掲載された異常気象等に関する気象情報等の写し",
    }
  },
  unexpectedEventRegisterModal: {
    titlePrefix: "予期し得ない事象への対応時間の",
    registerTitle: "登録",
    editTitle: "編集",
    startTime: "開始日時",
    endTime: "終了日時",
    totalTime: "所要時間",
    address: "対応を行った場所",
    note: "特例適用事由",
    documents: "予期し得ない事象の発生を特定できる客観的な資料",
    times: "{ hours }時間 { minuts }分"
  },
  workloadUpdateModal: {
    loadingOrRefuelingRegistration: "積載／給油量登録",
    work: "作業：",
    address: "住所・拠点：",
    arrivalDateTime: "着時間：",
    departureDateTime: "発時間：",
    quantity: "数量",
    unit: "単位",
    note: "備考（フリーテキスト欄）",
    operation: "操作",
    pieces: "個",
    liter: "L",
    gasStationType: "給油所種類",
    productName: "品名",
    newInput: "新規入力",
    noSaveMessage: "前の画面で未保存の操作があります。「保存」または「閉じる」をクリックしてから積載量／給油量の編集をしてください。",
    selectproductName: "品名を入力してください",
    inputUnit: "単位を入力してください"
  },
  messages: {
    getTenko: "点呼データを取得中です。しばらくお待ちください。",
    errorAllDisplay: "エラー内容を全て表示する",
    registered: "登録しました。",
    successRegistSpot: "地点の登録に成功しました"
  },
  validation: {
    driverLimit: "「まとめて(ドライバー別)」で出力できるドライバーは1名です。",
    deliveryPlanLimit: "「まとめて(ドライバー別)」で出力できる運行数は最大2件です。",
    pleaseSelect: "選択してください",
  },
  errorMessage: {
    getList: "日報一覧の取得に失敗しました。",
    getTenko: "点呼データの取得中に異常が発生しました。",
    doesNotExistTenko: "乗務後点呼データが存在しません。",
    search: "検索に失敗しました",
    getData: "データの取得に失敗しました。",
    registered: "登録に失敗しました。",
    registSpot: "地点の登録に失敗しました",
    updateWorkSpot: "作業の地点情報の更新に失敗しました",
    detailCategory: {
      car_number: "車番",
      leaving_warehouse_date_time: "出庫日時",
      returning_warehouse_date_time: "帰庫日時"
    }
  },
  csv: {
    refuelImport: "給油量CSV入力",
    refuelExport: "給油量CSV出力",
    refuelImportTitle: "給油量の入力",
    refuelImportMessage: "ファイルを選択してください。「給油量CSV出力」でダウンロードしたファイルを編集して、こちらからアップロードします。"
  }
}
